export default "__VITE_ASSET__BRB9OvMT__"